let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (domLoaded && igReady) {
    // Test: V_PSD_PDP_58 | Clickable Store-Benefit Tabs in Product Hero
    const pdp58Test = window.igData?.user.getTestGroup(
      "dbd0ef4d-8f6d-4f91-a5e1-3fe05937b92d"
    );
    if (pdp58Test?.id === "9564a124-7452-4cd9-8b72-0c08a77b3a32") {
      document.body.classList.add("c-pdp58VarA");
    }
  }
}

function swapBrandsAndCoatTypes() {
  if (window.innerWidth >= 1024) {
    return false;
  }

  let menuRoot = document.querySelector("component-menu[data-menu] > div.flex");
  if (!menuRoot) {
    menuRoot = document.querySelector(
      "component-menu[data-menu] .flex.flex-col"
    );
  }
  if (!menuRoot) {
    return false;
  }
  if (menuRoot.dataset.cSwapDone === "1") {
    return true;
  }

  // Compute wrappers as direct children of menuRoot
  let brandsItem = null;
  let coatTypesItem = null;
  const children = Array.from(menuRoot.children);
  children.forEach((el) => {
    const a = el.querySelector("[data-menu-level1-link]");
    if (!a) return;
    const text = (a.textContent || "").trim().toLowerCase();
    if (text === "brands") brandsItem = el;
    if (text === "coat types") coatTypesItem = el;
  });

  if (!brandsItem || !coatTypesItem || brandsItem === coatTypesItem)
    return false;

  const idxBrands = children.indexOf(brandsItem);
  const idxCoat = children.indexOf(coatTypesItem);

  if (idxBrands === -1 || idxCoat === -1) return false;

  // Ensure Brands appears before Coat Types
  if (idxBrands > idxCoat) {
    menuRoot.insertBefore(brandsItem, coatTypesItem);
  }
  menuRoot.dataset.cSwapDone = "1";
  return true;
}

function trySwapWithRetries(maxAttempts = 10, delayMs = 200) {
  let attempts = 0;
  const attempt = () => {
    attempts += 1;
    const ok = swapBrandsAndCoatTypes();
    if (!ok && attempts < maxAttempts) {
      setTimeout(attempt, delayMs);
    }
  };
  setTimeout(attempt, 0);
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("c-savingsAnchorVarA");
  domLoaded = true;
  handleExperiments();
});

document.addEventListener("DOMContentLoaded", () => {
  trySwapWithRetries();
  function updateThumbnailClass() {
    if (window.innerWidth < 1024) {
      document.body.classList.add("c-thumbnail-pdp");
    } else {
      document.body.classList.remove("c-thumbnail-pdp");
    }
  }

  updateThumbnailClass();

  window.addEventListener("resize", updateThumbnailClass);
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
